// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__VQKnG","inner":"PageHeader_inner__D6qX9","copy":"PageHeader_copy__h9MGJ","actions":"PageHeader_actions__0f7nk"};